import Constant from '@/const';
import axios from 'axios';

const getAllergies = async type => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/allergy/${type}`),
    );
    return response;
  } catch (error) {
    const err = error;
    return err;
  }
};

export default getAllergies;
